import { render, staticRenderFns } from "./OrderTypologyFits.vue?vue&type=template&id=539b5a1c&"
import script from "./OrderTypologyFits.vue?vue&type=script&lang=js&"
export * from "./OrderTypologyFits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports